module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch1",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "aria-label": "9",
      "id": "pg_9",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Futura_Std_Medium_Condensed_11"
  }, [_vm._v("THEN")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline---Chapter--dl-"
  }, [_c('span', {
    staticClass: "Futura_Std_Light_Condensed_11"
  }, [_vm._v("FORT DETRICK"), _c('br'), _vm._v("FREDERICK, MARYLAND"), _c('br'), _vm._v("AUGUST 12, 1984")])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Opening-Text-No-Indent--cotx1-"
  }, [_vm._v("Maureen LaVelle had spent forty minutes cooling her heels in the stuffy waiting room in a rear corner of the USAMRMC offices. The mystery man who’d summoned her, whoever he was, wasn’t just wasting her time—she had work to do, dammit—he was wasting the government’s money as well, because she was on the clock. If she’d known about the delay, she’d have come prepared, brought journals, or a novel. Everyone on base was reading "), _c('i', [_vm._v("Pet Sematary")]), _vm._v(" so she’d picked up a copy. She hadn’t figured it for her kind of book but she was getting into it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("An MP suddenly appeared and ushered her into a tiny office.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("About time.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("A thin, pale man she’d never seen before sat behind a general-issue desk. Without looking up he indicated the lone chair as he told the MP to leave and close the door behind him. The desktop lay bare except for a personnel folder and a small metal canister emblazoned with the international biohazard symbol.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He opened the folder, saying, “Doctor Maureen LaVelle,” in a flat, dry tone. “Your Ph.D. is in molecular biophysics, is that correct?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He wore a gray suit, white shirt, and navy blue tie. He hadn’t looked at her yet.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“That is correct. And you are …?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("Now")]), _vm._v(" he looked up—puffy face with gray eyes behind rimless glasses. Add a little mustache and he could go trick-or-treating as Himmler.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Benjamin Greve, at your service.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "10",
      "id": "pg_10",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Are you new here? I haven’t—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“—seen me before? That’s because I’m not here.” A twist of his thin lips that maybe passed for a smile. “Not officially. I came up from D.C. this morning and will be heading back tonight. To Anacostia, to be precise.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Anacostia … she sensed he’d dropped that for a specific purpose, and then remembered the Defense Intelligence Agency was headquartered at Anacostia-Bolling. Shit. A DIA spook. What did he think she’d done?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Greve was looking at her file again. “Born in Pikesville twenty-seven years ago, blasted through undergrad in three years, then on to your doctorate. Both at UMD, I see. Don’t like to stray far from the nest, is that it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Maureen’s mouth felt a little dry. She cleared her throat. “I have family in the area and I did some research here on my thesis.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“And you stayed on.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“They made me a nice offer as a civilian employee.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Government benefits—hard to beat in the current job market.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“How do you like the work?” he said, still flipping pages. This couldn’t be the first time he’d seen her file. “Challenging?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“It’s holding my interest.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Truth was, everything got routine after a while. Her work centered on defense against biological weapons—early detection and treatment—and as a result she got to work with some deadly organisms and impressive toxins. But she’d never broken security. Why was DIA here?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Finally he looked up again. “How would you like a "), _c('i', [_vm._v("real")]), _vm._v(" challenge?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She felt her shoulders relax. So that was it: a problem that needed solving. She was sure she could handle whatever they threw at her. Well, pretty sure.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I’m all ears.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He tapped the metal biohazard cylinder to his right, about the height and width of a half gallon of orange juice.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“We want you to identify what’s in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("An impatient scowl. “If I knew that, I wouldn’t be here asking you to identify it, would I?” He shook his head. “Damn! They told me you were smart, the best they had. Am I going to regret choosing you for this?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("… "), _c('i', [_vm._v("the best they had ?")]), _vm._v(" She wondered who’d said that. USAMRMC wasn’t quick with the compliments.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "11",
      "id": "pg_11",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("But she was not about to apologize. “The question isn’t as dumb as it sounds, Mister Greve. I’m curious as to whether it’s animal, vegetable, or mineral. Because if it’s mineral—”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“We don’t know what the hell it is, Doctor LaVelle,” he said in a testy tone. “That’s the problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Where did you get it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“That I can’t tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Can I ask you why Fort Detrick?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Because you have a level-four biosafety lab.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“So it’s toxic?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("A dramatic sigh. “We don’t know for sure. So far there’s no indication that it is, but it might be. We expect you to tell us if it is and, if so, exactly "), _c('i', [_vm._v("how")]), _vm._v(" toxic.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Fair enough. But why me?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Besides coming highly recommended as a researcher, another of the reasons you were chosen is because, in a very short time, you have built a reputation for taking anti-contamination and security protocols very seriously.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“That’s simple common sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Which many people lack. Also you appear devoted to your work. I can tell by your frumpy clothes and lack of makeup that you’re not on the hunt for a husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Maureen couldn’t help bristling, but she refused to acknowledge his words’ sting.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“I call them ‘comfortable’ clothes, and makeup bores me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She might have added that her hair was short and simply styled because she couldn’t be bothered fussing with it. Her mother had forced her to wear it long during high school and it had annoyed her to no end. And as for a man … true, she wasn’t on the hunt, but if the right one came along—and he’d have to be "), _c('i', [_vm._v("very")]), _vm._v(" right—she’d be game.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He tapped the container again. “I cannot impress upon you strongly enough how highly classified this substance is.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Okay, now she was "), _c('i', [_vm._v("really")]), _vm._v(" interested.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Does it have a name?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“It’s been designated ‘Substance A.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('i', [_vm._v("A?")]), _vm._v(" she thought. As in the letter "), _c('i', [_vm._v("A")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Does that mean there are substances B and C and so on after it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "12",
      "id": "pg_12",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“ ‘Substance A’ is all you need to know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Well, can you tell me if it’s liquid, gaseous, or solid?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Semi-solid. It pours.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Good. Now we’re getting somewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Synthetic or natural or—?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("He held up a hand. “It "), _c('i', [_vm._v("is")]), _vm._v(". That’s all I can say. You will gain firsthand knowledge while you are investigating its properties.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“When do I get started?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“In a few moments.” He lifted a briefcase onto the desk and removed a sheaf of documents. “But first, some NDAs for you to sign.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She’d signed a ream of nondisclosure agreements when she’d done her thesis research here, and even more when she’d hired on.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“They’re already on file.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("That non-smile again. “Not these. These are ad hoc documents.”")]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("“The first thing I want you to do is weigh it,” Greve said. “Then I’ll leave you to your investigations.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Well, that was a relief. He’d followed her to the BSL-4 lab and she’d been afraid he’d be keeping watch over her shoulder for as long as this took—which might stretch to days or weeks. He gave her the creeps.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The sealed specimen cylinder sat on the other side of the glass. Maureen slipped her hands into the gloved sleeves that stretched into the containment area and placed a 600-milliliter glass beaker on a scale. After zeroing it out, she unscrewed the cylinder top and gently tilted it over the beaker.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("A glistening, viscous substance, reddish-purplish-blackish—the color of a bad bruise—began to ooze out. When it reached the 400-milliliter mark on the beaker it stopped. Maureen examined the inside of the cylinder and saw no trace of residue.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She checked the scale. The LED display read zero. She tapped it. Still zero. She pressed gently on the top of the beaker and the numbers climbed, but when she removed her hand, back to zero.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“That can’t be.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“At this point, that’s the only thing we know about it,” Greve said, literally hanging over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_c('span', {
    attrs: {
      "aria-label": "13",
      "id": "pg_13",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“But that’s impossible. It has mass, it pours, it obeys the pull of gravity, so it can’t weigh nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“You checked your scale. It’s working.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“But if it were weightless, it wouldn’t pour, it would … float.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“So one would think.” He bent and lifted his briefcase. “I leave you to your work, Doctor LaVelle. My secure fax number is on my card. I expect a report every evening by five "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Maureen nodded, his words barely registering. She couldn’t take her eyes off the bruise-colored mass in the beaker.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Where on Earth do you find weightless slime? Or maybe not on Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("She shook off the discomfort and reached for the radio. She liked music while she worked. A top-forty DJ announced the number-one song in America, and “Ghostbusters” began to thump through the tiny speaker.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("The line about “something weird” that “don’t look good” struck her.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("How appropriate, she thought. Almost prescient.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("And who y’gonna call?")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("Moe LaVelle, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "Text---Standard--tx-"
  }, [_vm._v("“Okay, you slimy mess. Let’s see what other spookiness you’re hiding.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f604df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 72
// module chunks = 0